﻿{
  "community": {
    "name": "Community",
    "titles": {
      "1": "Nettsamfunn",
      "2": "Finn materiell",
      "3": "Del det du har laget"
    },
    "body": {
      "1": "Et flott sted for å ta en titt på alt det Boardmaker kan tilby",
      "2": "Se hva andre lager og deler. Det er som et vindu inn til Boardmaker-magien!",
      "3": "Med din foretrukne Boardmaker-programvare kan du laste opp og dele det du har laget med resten av fellesskapet"
    }
  },
  "personal": {
    "name": "Personlig abonnement",
    "header": "Inkluderer alt i Community-abonnement, pluss:",
    "titles": {
      "1": "Opprett, rediger, spill og skriv ut",
      "2": "Boardmaker-programvare"
    },
    "body": {
      "1": "For en forelder eller omsorgsperson med ett barn, som ønsker å lage, redigere, spille og skrive ut aktiviteter",
      "2": "Kontoer kommer med en Boardmaker 7-lisens som kan installeres på opptil 2 Windows-datamaskiner"
    }
  },
  "professional": {
    "name": "Profesjonelt abonnement",
    "header": "Inkluderer alt i Personlig abonnement, pluss:",
    "titles": {
      "1": "Studentledelse",
      "2": "Individualiserte innstillinger"
    },
    "body": {
      "1": "For instruktører med 1 til 50 elever, som ønsker å tildele oppgaver og spore elevdata",
      "2": "Tilpassede tilgangsinnstillinger for hver elev"
    }
  },
  "organization": {
    "name": "Organisasjonsabonnement",
    "header": "Inkluderer alt i Profesjonelt abonnement, pluss:",
    "titles": {
      "1": "Støtte for tverrfaglige team"
    },
    "body": {
      "1": "Volumpriser, organisasjonen kontrollerer informasjonen, og flere personer kan tildele oppgaver til de samme elevene"
    }
  }
}
